import consumer from "./consumer"

// BillingStatementChannelとのやり取りを行うスクリプト

// ----------------------------------------------------------
// BillingStatementChannelのsubscribe / unsubscribe
// ----------------------------------------------------------

var billing_statement_channel

// 遷移前がbilling_statement_channelの場合unsubscribe
$(document).on('turbolinks:before-render', () => {
  if (connect_statement_channel() && consumer.subscriptions.subscriptions.length >= 1) {
    console.log('billing_statement_channel.unsubscribe')
    billing_statement_channel.unsubscribe()
  }
})

// 遷移後がbilling_statement_channelの場合subscribe
$(document).on('turbolinks:load', () => {
  if (connect_statement_channel()) {
    billing_statement_channel = consumer.subscriptions.create({channel: "BillingStatementChannel"},
    {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log('connected.')
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
        console.log('disconnected.')
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        console.log('received.')
        console.dir(data)

        switch (data['type']) {
          case 'statement_status_changed':
            statement_status_changed(data['sid'], data['contents'])
            break
        }
      }
    });
  }
})

// statementchannelにつなぐ条件 -> #statement-channelが存在すること
function connect_statement_channel() {
  if ($('#statement-channel').length > 0) {
    return true
  }
  else {
    return false
  }
}


// ----------------------------------------------------------
// BillingStatementChannelからのレスポンス・通知を処理
// ----------------------------------------------------------
function statement_status_changed(sid, contents) {
  $.each(contents, (key, value) => {
    if (key == 'error_tr_class'){
      var id = 'tr#s' + sid + '_tr'
      var elm = $(id)
      if (!elm.length) {
        console.log(`skip ${key}`)
        return true
      }
      statement_change_tr_class(elm, value)
    } else {
      var id = 'td#s' + sid + '_' + key
      var elm = $(id)
      if (!elm.length) {
        console.log(`skip ${key}`)
        return true
      }
      statement_change_contents(elm, value)
    }
  })
}

function statement_change_contents(elm, content) {
  var before = null;
  var after = null;
  
  before = elm.html()
  after = content

  if (before != after) {
    elm.html(content)

    elm.addClass('value-changed')
    elm.delay(1500).queue(() => {
      elm.removeClass('value-changed').dequeue()
    })
  }
}

function statement_change_tr_class(elm, content) {
  var before = null;
  var after = null;
  
  if (elm.hasClass('table-danger')){
    before = 'table-danger'
  } else {
    before = ''
  }
  after = content

  if (before != after) {
    if (before == 'table-danger') {
      elm.removeClass('table-danger')
    } else {
      elm.addClass('table-danger')
    }
  }
}
